import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import * as _ from "lodash";
import moment from "moment";
import SortOptions from "../../../../models/content-wrapper/sort-options";
import CompanyResourceType from "../../../../models/resource-management/company-resource-type.enum";
import SelectFormInput from "../../../../models/SelectFormInput";
import { NavBarServiceProvider } from "../../../../providers/nav-bar-service/nav-bar-service";
import { ResourceManagementService } from "../../../../providers/resource-management/resource-management.service";
import { UtilityService } from "../../../../providers/utility-service/utility-service";
import { OrderForm } from "../order-form/order-form";

@Component({
  selector: "visit-frequency-order-form",
  templateUrl: "visit-frequency-order-form.html",
})
export class VisitFrequencyOrderFormComponent
  extends OrderForm
  implements OnInit
{
  private isFeatureToggle: boolean;
  private startDateMin: string = "";
  private startDateMax: string = "";
  private endDateMin: string = "";
  private endDateMax: string = "";
  private textAreaMaxLength = 500;
  defaultStartTime: string = "";

  @Input() set disciplineOptions(disciplineOptions: SelectFormInput[]) {
    this.filteredDisciplineOptions =
      this.getFilteredDisciplineOptions(disciplineOptions);
  }
  @Input() visitFrequencyOptions: SelectFormInput[] = [];
  @Input() prnVisitsOptions: SelectFormInput[] = [];
  @Input() reasonOptions: SelectFormInput[] = [];
  @Input() timeIntervalOptions: SelectFormInput[] = [];
  @Input() physicianOptions: SelectFormInput[] = [];
  @Input() physicianOrderOptions: SelectFormInput[] = [];
  @Input() status: any;
  @Input() isOpenOrderEdit: boolean = false;
  @Input() isActiveOrderEdit: boolean = false;
  @Output() onValidityChange: EventEmitter<any> = new EventEmitter();

  discipline: string = "";

  filteredDisciplineOptions = [];

  acceptedDisciplineEnums = [
    "MD",
    "CM",
    "TL",
    "NP",
    "VC",
    "RN",
    "LN",
    "SW",
    "SA",
    "BM",
    "HA",
    "VOL",
    "HM",
  ];

  protected incomingData: any;

  protected orderForm: FormGroup;

  hidePhysiciansOptions: Boolean = true;
  searchTerm: string = "";
  selectPhysicianFlag: boolean = false;
  setPhysicianName: boolean = false;

  hideDcPhysiciansOptions: Boolean = true;
  dcSearchTerm: string = "";
  selectDcPhysicianFlag: boolean = false;
  setDcPhysicianName: boolean = false;

  private physicians: any = [];

  constructor(
    private formBuilder: FormBuilder,
    private navBarService: NavBarServiceProvider,
    private resourceManagementService: ResourceManagementService,
    public utilityService: UtilityService
  ) {
    super();
    this.startDateMin = moment().subtract("10", "years").format("YYYY-MM-DD");
    this.startDateMax = moment().add("10", "years").format("YYYY-MM-DD");
    this.endDateMin = moment().subtract("10", "years").format("YYYY-MM-DD");
    this.endDateMax = moment().add("10", "years").format("YYYY-MM-DD");
    this.defaultStartTime = moment().format("YYYY-MM-DD");

    this.orderForm = this.formBuilder.group({
      discipline: [
        "",
        Validators.compose([Validators.minLength(1), Validators.required]),
      ],
      role: [""],
      otherRole: [""],
      visits: [
        "",
        Validators.compose([Validators.minLength(1), Validators.required]),
      ],
      timeInterval: [
        "",
        Validators.compose([Validators.minLength(1), Validators.required]),
      ],
      prnVisits: [""],
      reason: [""],
      physician: ["", Validators.compose([Validators.required])],
      itemStartDatetime: ["", Validators.compose([Validators.required])],
      itemDiscontinueDatetime: [""],
      physicianOrder: ["", Validators.compose([Validators.required])],
      physicianOrderNotes: [
        "",
        Validators.compose([Validators.maxLength(this.textAreaMaxLength)]),
      ],
      searchTerm: new FormControl(""),
      dcSearchTerm: new FormControl(""),
    });
    this.isFeatureToggle = this.navBarService.featureToggleOn("NEWCAL");

    this.orderForm.valueChanges.subscribe((data) => {
      console.log(data, this.orderForm.valid);
      // if(this.orderForm.controls['discipline'].value==="" && this.discipline!==""){
      //     this.orderForm.controls['discipline'].setValue(this.discipline);
      // }
      this.onValidityChange.emit({
        validity: this.orderForm.valid,
        data: data,
      });
    });

    //enforce character limit
    this.orderForm.controls["physicianOrderNotes"].valueChanges.subscribe(
      (data) => {
        if (data.length > this.textAreaMaxLength) {
          this.orderForm.controls["physicianOrderNotes"].setValue(
            data.substring(0, this.textAreaMaxLength)
          );
        }
      }
    );

    //enforce startDate cannot be after endDate
    this.orderForm.controls["itemStartDatetime"].valueChanges.subscribe(
      (data) => {
        let startDate = moment(data).format("YYYY-MM-DD");
        let endValue = this.orderForm.controls["itemDiscontinueDatetime"].value;

        if (endValue.length > 0) {
          let endDate = moment(endValue).format("YYYY-MM-DD");
          if (moment(startDate).isAfter(endDate)) {
            this.orderForm.controls["itemStartDatetime"].setValue("");
          }
        }
        this.endDateMin = moment(data).format("YYYY-MM-DD");
      }
    );

    //enforce endDate cannot be before startDate
    this.orderForm.controls["itemDiscontinueDatetime"].valueChanges.subscribe(
      (data) => {
        let startValue = this.orderForm.controls["itemStartDatetime"].value;
        let endDate = moment(data).format("YYYY-MM-DD");

        if (startValue.length > 0) {
          let startDate = moment(startValue).format("YYYY-MM-DD");
          if (moment(startDate).isAfter(endDate)) {
            this.orderForm.controls["itemDiscontinueDatetime"].setValue("");
          }
        }
        this.startDateMax = moment(data).format("YYYY-MM-DD");
      }
    );

    // if(!this.incomingData) {
    //   this.dataSvc.getUserInfo().subscribe(
    //       data=>{
    //         this.orderForm.controls['discipline'].setValue(data['persons'][0]['discipline']);
    //     }
    //   );
    // }
    // this could be used to determine the default value of the field

    this.orderForm.controls["discipline"].valueChanges.subscribe((data) => {
      if (!this.acceptedDisciplineEnums.includes(data)) {
        //If it's a free text other value, set stuff appropriately
        this.orderForm.controls["role"].setValue("OTH");
        this.orderForm.controls["otherRole"].setValue(data);
      } else {
        this.orderForm.controls["role"].setValue(data);
      }
    });
  }

  ngOnInit() {
    if (this.incomingData) {
      if (this.incomingData.rmPhysician) {
        this.searchTerm = this.incomingData.rmPhysician.displayName;
      }

      //setting this here because of discrepancy between role/discipline
      this.orderForm.controls["discipline"].setValue(this.incomingData.role);

      //apply limits to prevent startDate > endDate if data exists
      let startDatetime = this.incomingData.itemStartDatetime;
      if (startDatetime) {
        this.endDateMin = moment(startDatetime).format("YYYY-MM-DD");
      }
      let endDatetime = this.incomingData.itemDiscontinueDatetime;
      if (endDatetime) {
        this.startDateMax = moment(endDatetime).format("YYYY-MM-DD");
      }
      // if (this.isFeatureToggle && this.incomingData['timeInterval'] === 'day') {
      //     this.onChangeTimeInterval(this.incomingData['timeInterval']);
      // }
      if (this.isFeatureToggle && this.incomingData.timeInterval === "day") {
        this.onChangeTimeInterval(this.incomingData.timeInterval);
      }
    }
    // if discontinue make itemDiscontinueDatetime required
    if (this.status === "discontinue") {
      let discDate = this.orderForm.get("itemDiscontinueDatetime");
      discDate.setValidators([Validators.required]);
      discDate.updateValueAndValidity();
      this.orderForm.addControl(
        "dcPhysician",
        new FormControl("", Validators.required)
      );
      this.orderForm.controls["dcPhysician"].updateValueAndValidity();
    }
  }

  getFilteredDisciplineOptions(disciplineOptions) {
    return disciplineOptions.filter((role) =>
      this.acceptedDisciplineEnums.includes(role.value)
    );
  }
  onChangeTimeInterval(value) {
    if (value === "day") {
      this.visitFrequencyOptions.map((element) => {
        if (element.value === "1 time") {
          element["disabled"] = false;
        } else {
          element["disabled"] = true;
          this.orderForm.controls["visits"].reset();
        }
      });
    } else {
      this.visitFrequencyOptions.map((element) => {
        element["disabled"] = false;
      });
    }
  }

  /**
   * @param searchTerm user enters to search the physician, when the term length is > 2 at that time call that getPhysicians api
   */
  searchPhysicians(searchTerm: string) {
    if (searchTerm !== "") {
      this.hidePhysiciansOptions = false;
      if (searchTerm.length > 2) {
        this.getPhysicians(searchTerm);
      }
    }
  }

  /**
   * @param searchTerm search term to get physicians
   */
  getPhysicians(searchTerm) {
    if (!this.selectPhysicianFlag) {
      this.selectPhysicianFlag = false;
      this.setPhysicianName = true;
      this.resourceManagementService
        .getCompanyResourceSummaries(
          0,
          10000,
          searchTerm,
          new SortOptions("last_name", "asc"),
          CompanyResourceType.PROVIDER
        )
        .subscribe(
          (response) => {
            this.physicians = [];
            let providers = _.filter(response.content, (x) => x.externalId); // valid external Id.
            this.physicians = this.physicians.concat(providers);
          },
          (err) => {
            this.utilityService.presentErrorToast(
              err,
              "Failed to Load Providers"
            );
          }
        );
    } else {
      this.selectPhysicianFlag = false;
    }
  }

  setPhysician(physician: any) {
    this.selectPhysicianFlag = true;
    this.setPhysicianName = false;
    this.hidePhysiciansOptions = true;
    this.orderForm.controls["physician"].setValue(physician);
    this.orderForm.controls["searchTerm"].setValue(physician.displayName);
  }
  /**
   * @param searchTerm user enters to search the physician, when the term length is > 2 at that time call that getPhysicians api
   */
  searchDcPhysicians(searchTerm: string) {
    if (searchTerm !== "") {
      this.hideDcPhysiciansOptions = false;
      if (searchTerm.length > 2) {
        this.getDcPhysicians(searchTerm);
      }
    }
  }

  /**
   * @param searchTerm search term to get physicians
   */
  getDcPhysicians(searchTerm) {
    if (!this.selectDcPhysicianFlag) {
      this.selectDcPhysicianFlag = false;
      this.setDcPhysicianName = true;
      this.resourceManagementService
        .getCompanyResourceSummaries(
          0,
          10000,
          searchTerm,
          new SortOptions("last_name", "asc"),
          CompanyResourceType.PROVIDER
        )
        .subscribe(
          (response) => {
            this.physicians = [];
            let providers = _.filter(response.content, (x) => x.externalId); // valid external Id.
            this.physicians = this.physicians.concat(providers);
          },
          (err) => {
            this.utilityService.presentErrorToast(
              err,
              "Failed to Load Providers"
            );
          }
        );
    } else {
      this.selectDcPhysicianFlag = false;
    }
  }

  setDcPhysician(physician: any) {
    this.selectDcPhysicianFlag = true;
    this.setDcPhysicianName = false;
    this.hideDcPhysiciansOptions = true;
    this.orderForm.controls["dcPhysician"].setValue(physician);
    this.orderForm.controls["dcSearchTerm"].setValue(physician.displayName);
  }
}



// WEBPACK FOOTER //
// ./src/components/orders/forms/visit-frequency-order-form/visit-frequency-order-form.ts